import React from 'react';

function AboutPage() {
    return (
        <>
            <h2>About Us</h2>
            <div class="pdfreader">
                <iframe src="documents/our socialism.pdf"></iframe>
                {/*<a href="documents/our socialism.pdf" download="our socialism.pdf">Download Our Socialism PDF</a>*/}
            </div>
            <h3>More Coming Soon</h3>
         </>
    );
}

export default AboutPage;